import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userId: null,
  userData: null,
  // Текущий шаг регистрации (для возврата на него после ухода со страницы)
  registrationStep: null,
  registrationData: {
    // Step 1 data
    name: "",
    gender: "",
    birthDay: "",
    country: "",
    city: "",
    coordinates: {
      latitude: null,
      longitude: null,
    },

    // Step 2 data
    photos: [null, null, null, null],

    // Step 3 data
    audioMessage: null,
    about: "",

    // Step 4 data
    purpose: null,

    // Step 5 data
    interests: [],
  },
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
    setRegistrationStep: (state, action) => {
      state.registrationStep = action.payload;
    },
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    updateRegistrationData: (state, action) => {
      state.registrationData = {
        ...state.registrationData,
        ...action.payload,
      };
    },
    // Step 2 actions
    updatePhoto: (state, action) => {
      const { index, photo } = action.payload;
      state.registrationData.photos[index] = photo;
    },
    deletePhoto: (state, action) => {
      const index = action.payload;
      state.registrationData.photos[index] = null;
    },
    reorderPhotos: (state, action) => {
      const { fromIndex, toIndex } = action.payload;
      const photos = [...state.registrationData.photos];
      const [movedPhoto] = photos.splice(fromIndex, 1);
      photos.splice(toIndex, 0, movedPhoto);
      state.registrationData.photos = photos;
    },
    clearPhotos: (state) => {
      state.registrationData.photos = [null, null, null, null];
    },
    // Step 3 actions
    setAudioMessage: (state, action) => {
      if (action.payload && Object.keys(action.payload).length > 0) {
        console.log("💾 [Redux] Сохраняем аудио в store:", action.payload);
        state.registrationData.audioMessage = {
          audioId: action.payload.audioId || null,
          audioUrl: action.payload.audioUrl || null,
          size: action.payload.size || 0,
          duration: action.payload.duration || 0,
          // Для совместимости со старым кодом
          file: action.payload.file,
          bars: action.payload.bars,
          blob: action.payload.blob,
        };
        console.log("✅ [Redux] Аудио сохранено в store");
      } else {
        // Если payload пустой, очищаем аудио сообщение
        console.log("🗑️ [Redux] Очищаем аудио из store");
        state.registrationData.audioMessage = null;
      }
    },

    // Step 4 actions
    setPurpose: (state, action) => {
      state.registrationData.purpose = action.payload;
    },
    // Step 5 actions
    setInterests: (state, action) => {
      state.registrationData.interests = action.payload;
    },
    addInterest: (state, action) => {
      const interest = action.payload;
      if (!state.registrationData.interests.includes(interest)) {
        state.registrationData.interests.push(interest);
      }
    },
    removeInterest: (state, action) => {
      const interest = action.payload;
      state.registrationData.interests =
        state.registrationData.interests.filter((i) => i !== interest);
    },
    clearAllUserData: (state) => {
      // Очищаем все данные пользователя при удалении аккаунта
      state.userId = null;
      state.userData = null;
      state.registrationStep = null;
      state.registrationData = {
        name: "",
        gender: "",
        birthDay: "",
        country: "",
        city: "",
        coordinates: {
          latitude: null,
          longitude: null,
        },
        photos: [null, null, null, null],
        audioMessage: null,
        about: "",
        purpose: null,
        interests: [],
      };
    },
  },
});

export const {
  setUserId,
  setRegistrationStep,
  setUserData,
  updateRegistrationData,
  updatePhoto,
  deletePhoto,
  reorderPhotos,
  clearPhotos,
  setAudioMessage,
  setPurpose,
  setInterests,
  addInterest,
  removeInterest,
  clearAllUserData,
} = userSlice.actions;

export default userSlice.reducer;
